import { Formik, Form } from 'formik';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import styles from './../login/Login.module.css';
import { FormikTextField } from '../../components/form-components/common-components/text-field/FormikTextField';
import { useStore } from '../../hooks/useStore';
import { Box } from '@mui/material';
import KaldenLogo from '../../assets/kalden-logo.png';
import { ForgotPasswordSchema } from '../../schemas/ForgotPasswordSchema';
import {
  ForgotPasswordFormValues,
  forgotPasswordInitialValues,
} from '../../models/user/UserModels';
import { RsValue } from '../../models/base/BaseModel';

export const ForgotPassword = () => {
  const { authStore } = useStore();

  const handleSubmit = async (values: ForgotPasswordFormValues) => {
    try {
      const response: RsValue<string> = await authStore.forgotPassword({ email: values.email });

      if (response.error) {
        toast.error(response.message || 'Şifre sıfırlama linki gönderilemedi');
        return;
      }

      toast.success(response.message || 'Şifre sıfırlama linki e-posta adresinize gönderildi.');
    } catch (error) {
      console.error(error);
      toast.error('Şifre sıfırlama işlemi sırasında bir hata oluştu');
    }
  };

  return (
    <div className={styles.container}>
      <img src={KaldenLogo} alt="Kalden Logo" className={styles.logo} />
      <div className={styles.formWrapper}>
        <h1 className={styles.title}>Şifre Sıfırlama</h1>
        <Formik
          initialValues={forgotPasswordInitialValues}
          validationSchema={ForgotPasswordSchema}
          onSubmit={handleSubmit}
        >
          {({ isSubmitting }) => (
            <Form className={styles.form}>
              <FormikTextField
                name="email"
                label="E-posta Adresi"
                type="email"
                placeholder="E-posta adresinizi giriniz"
              />
              <button type="submit" className={styles.submitButton} disabled={isSubmitting}>
                {isSubmitting ? 'Gönderiliyor...' : 'Sıfırlama Linki Gönder'}
              </button>

              <div className={styles.registerLink}>
                <Link to="/login">Giriş Sayfasına Dön</Link>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};
